// extracted by mini-css-extract-plugin
module.exports = {"sm":"0","md":"46.875rem","lg":"63.9375em","xl":"80em","specifications":"Specifications_specifications__Z4BY_","full_column":"Specifications_full_column__q5DGH"};